import { createNanoEvents } from 'nanoevents';
export const streamEvents = createNanoEvents();
//# sourceMappingURL=events.js.map